module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticStyle: {
      "margin-bottom": "5px",
      "padding": "5px",
      "display": "flex"
    }
  }, [_c('div', {
    staticClass: "pa-1"
  }, [_c('img', {
    staticClass: "round",
    staticStyle: {
      "border": "solid 1px #eee",
      "width": "40px",
      "height": "40px"
    },
    attrs: {
      "src": "/static/images/user-placeholder.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pa-1"
  }, [_vm._v("\n        " + _vm._s(_vm._f("fullName")(_vm.contact)) + "\n    ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ff581fe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/ContactCard.vue
// module id = 2575
// module chunks = 1